function isAbsoluteURL(url){return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url)}

export { isAbsoluteURL as default };
//# sourceMappingURL=isAbsoluteURL.js.map
